import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductDownloadReq } from 'src/app/model/product-download-req';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ProgressStatus, ProgressStatusEnum } from 'src/app/model/progress-status';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { ProductDto } from 'src/app/model/ProductDto';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/core/services/product.service';
import { Languages, Productlanguage } from 'src/app/model/ProductLanguages';
import { TranslateService } from '@ngx-translate/core';
import { AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ProductCode } from 'src/app/model/industry';

@Component({
  selector: 'ms-product-version-card',
  templateUrl: './product-version-card.component.html',
  styleUrls: ['./product-version-card.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class ProductVersionCardComponent implements OnInit, OnDestroy {
  @Input() productRelease!: ProductRelease;
  @Input() family!: string;
  @Input() downloadable: boolean = false;
  @Input() isLargeVersionCard: boolean = false;
  @Input() isPlatinumPartner: boolean = false;

  public progressStatus: ProgressStatus = new ProgressStatus();
  isLoading: boolean = false;
  buttonDisabled: boolean = false;
  blockDownload: boolean = true;
  isMainProduct: boolean = false;
  selectableLanguages: string[] = [];
  downloadLanguages: string[] = [];
  isDeveloper: boolean;
  mainProducts = ["MAGOCLD", "MAGOWEB", "MAGO4", "MAGO.NET"];
  productLanguages: Productlanguage[] = [
    new Productlanguage("CRMCONN", ["it-IT", "en-US"]),
    new Productlanguage("MAGO4", ["it-IT", "en-US", "pt-BR"]),
    new Productlanguage("MAGO.NET", ["it-IT", "en-US"]),
    new Productlanguage("TBS", ["it-IT", "en-US"]),
  ] 
  errorTitle: string;
  errorDescription: string;
  //list: string[] = ["TESO_MN:1.3.2.HF1","TESO_MN:1.3.2.HF2","TESO_MN:1.3.3","TESO_MN:1.4","ESP_MN:3.14.7.P001","ESP_MN:3.14.7.P003","ESP_MN:3.14.7.P004","ESP_MN:3.14.7.P005","ESP_MN:3.14.7.P006","ESP_MN:3.14.8.P001","ESP_MN:3.14.9.P001","ESP_MN:3.14.9.P002","ESP_MN:3.14.12.P001"];

  constructor(
    private productDownloadService: ProductDownloadService,
    private workflow: WorkFlowService,
    private navigateService: NavigateService,
    private router: Router,
    private productService: ProductService,
    private translateService: TranslateService,
    public customerService: CustomerService
  ) {
    this.progressStatus = new ProgressStatus();
  }
  productDto: ProductDto;
  ngOnInit(): void {
    this.translateService.get(['COMMONS.DOWNLOADERRORTITLE','COMMONS.DOWNLOADERRORDESCRIPTION'])
    .subscribe(res => {
      this.errorTitle = res['COMMONS.DOWNLOADERRORTITLE']
      this.errorDescription = res['COMMONS.DOWNLOADERRORDESCRIPTION']
    })

    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');

    this.productLanguages = this.productLanguages.filter(pl => { return pl.ProductCode == this.productDto.ProductCode })

    if(this.productLanguages.length == 1)
      this.selectableLanguages = this.productLanguages[0].Languages
  }

  getProductCodeZucchetti(pc: string) {
    switch (pc) {
        case "MAGOWEB":
            return ProductCode.MAGOWEB;
        case "MAGOCLD":
            return ProductCode.MAGOCLD;
        case "MAGO4":
        case "MAGO.NET":
          return ProductCode.MAGO4;
    }
  }

  getLanguageString(languageCode: string): string {
    return Languages[languageCode] ? Languages[languageCode] : ''
  }

  public openFamilyReleases(){
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(this.productDto))
    this.router.navigate(['/products-download/family-releases']);
  }

  public openRelease(){
    let productDto = new ProductDto(this.family, this.productRelease.ProductCode, this.productRelease.ReleaseNr);
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(productDto))
    this.router.navigate(['/products-download/product-viewer']);
  }

  public isDownloadableProduct() {
    return  (this.productDto.ProductCode !="MAGOCLD")
  }

  getProductImage (prodKey: string){
    return this.productService.getProductImage(prodKey)
  }

  public download(language: string = '') {
    this.setDownloadInit();
    let reqBody = new ProductDownloadReq(this.productRelease.ProductCode, this.productRelease.ReleaseNr);

    this.productDownloadService.downloadProduct(reqBody, language, this.isPlatinumPartner).subscribe(
      async data => {
        if(data['ok'] == false){
          this.setDownloadError()
          if(data['status'] == 500)
            await this.productDownloadService.setNotFoundedProducts(this.productRelease.ProductCode, this.productRelease.ReleaseNr)
          this.workflow.showMessage(this.errorTitle, this.errorDescription);
          this.productDownloadService.downloadInfo(this.productRelease.ProductCode, this.productRelease.ReleaseNr, false)
          return;
        }

        else if(!this.blockDownload){
          switch (data.type) {
            case HttpEventType.DownloadProgress:
              this.setDownloadInProgress(Math.round((100 * data.loaded) / this.productRelease.PublishedFileSize))
              break;
            case HttpEventType.Response:
                this.productDownloadService.downloadInfo(this.productRelease.ProductCode, this.productRelease.ReleaseNr, true)
                this.setDownloadComplete();
                this.downloadFile(data);
              break;
          }
        }
      }
    );
  }

  public getFileName(publishedFileName: string): string{
    let multipleNames = publishedFileName.split(';');
    if(multipleNames.length == 1)
      return publishedFileName;
    else
      return this.isPlatinumPartner ? multipleNames[1] : multipleNames[0]
  }

  setDownloadInit(){
    this.isLoading = true;
    this.buttonDisabled = true;
    this.blockDownload = false;
    this.setDownloadStatus(ProgressStatusEnum.START, 0)
  }

  setDownloadInProgress(percentage: number){
    this.isLoading = false;
    this.buttonDisabled = true;
    this.setDownloadStatus(ProgressStatusEnum.IN_PROGRESS, percentage)
  }

  setDownloadComplete(){
    this.buttonDisabled = false;
    this.setDownloadStatus(ProgressStatusEnum.COMPLETE, 0)
  }

  ngOnDestroy(): void {
    this.buttonDisabled = false;
    this.isLoading = false;
    this.blockDownload = true;
    this.setDownloadStatus(ProgressStatusEnum.COMPLETE, 0)
  }

  setDownloadError(){
    this.buttonDisabled = false;
    this.isLoading = false;
    this.blockDownload = true;
    this.setDownloadStatus(ProgressStatusEnum.ERROR, 0)
  }


  setDownloadStatus(status: ProgressStatusEnum, percentage: number = 0){
    this.progressStatus.status = status;
    this.progressStatus.percentage = percentage;
  }

  downloadFile(data: HttpResponse<Blob>){
    const downloadedFile = new Blob([data.body], { type: data.body.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = this.getFileName(this.productRelease.PublishedFileName).includes('<EXT_GITHUB>') ? this.getFileName(this.productRelease.PublishedFileName).split('/')[this.getFileName(this.productRelease.PublishedFileName).split('/').length - 1] : this.getFileName(this.productRelease.PublishedFileName);
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }

  isinProgress(){
    return this.progressStatus.status == ProgressStatusEnum.IN_PROGRESS;
  }

  getDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString()
  }

  getReleaseFileSize(productRelease: ProductRelease){
    let size: number = (productRelease.PublishedFileSize != 2147483647 && productRelease.PublishedFileSize > 1) ? productRelease.PublishedFileSize : Number(productRelease.Notes);
    return size ? (size / 1048576).toFixed(2) : 0;
  }

}
